var map = {
	"./add-svgrepo-com.svg": "60a1",
	"./alert-circle.svg": "1ec1",
	"./align-center.svg": "86d7",
	"./align-left.svg": "d4aa",
	"./align-right.svg": "7526",
	"./arrow-left-2-w.svg": "582a",
	"./arrow-left.svg": "ac3b",
	"./arrow-next.svg": "17f9",
	"./arrow-right-2-w.svg": "27bd",
	"./arrow-right.svg": "cd8c",
	"./bag-w.svg": "3c5f",
	"./bank-card.svg": "82c8",
	"./bold.svg": "ff26",
	"./box-open.svg": "a074",
	"./box-svgrepo-com.svg": "436a",
	"./box.svg": "bb19",
	"./brand-adversal.svg": "5597",
	"./bread.svg": "3124",
	"./calendar-add.svg": "f193",
	"./calendar-w.svg": "a223",
	"./call-center.svg": "0d8d",
	"./call_history.svg": "c1f5",
	"./campaign.svg": "8872",
	"./capsules.svg": "940f",
	"./car-3-svgrepo-com.svg": "f0e6",
	"./cart-4.svg": "02bf",
	"./cart-plus.svg": "2b8b",
	"./cart-valid.svg": "210d",
	"./cart-white.svg": "0bc2",
	"./cart.svg": "daca",
	"./cash.svg": "c9a3",
	"./check-circle-colored.svg": "00eb",
	"./check-circle-fill.svg": "1630",
	"./check-circle-white.svg": "ba4a",
	"./check.svg": "7bae",
	"./clipboard-check.svg": "be6e",
	"./clock.svg": "755b",
	"./close-x.svg": "17b8",
	"./company.svg": "d53f",
	"./danger-circle-warning.svg": "642c",
	"./data-folder-svgrepo-com.svg": "b410",
	"./delivery-fast.svg": "2206",
	"./double-left-w.svg": "c037",
	"./double-right-w.svg": "35e4",
	"./download.svg": "f28e",
	"./edit.svg": "daf0",
	"./email-black.svg": "e999",
	"./email.svg": "43be",
	"./event-log.svg": "9e10",
	"./external-link.svg": "b64a",
	"./facebook.svg": "8485",
	"./family-of-3-whole-body-svgrepo-com.svg": "dc9f",
	"./fi-rr-angle-small-right.svg": "80ab",
	"./fi-rr-globe.svg": "4446",
	"./font.svg": "b8a2",
	"./grid-4-svgrepo-com.svg": "3cf7",
	"./hands-helping.svg": "9c78",
	"./history-lock.svg": "d461",
	"./home.svg": "ac9d",
	"./image-w.svg": "605b",
	"./image.svg": "931c",
	"./info-circle-w.svg": "0055",
	"./info-custom.svg": "9dca",
	"./info.svg": "76ed",
	"./instagram.svg": "bd6c",
	"./leaf.svg": "cdbd",
	"./lightbulb.svg": "5d90",
	"./linkedin.svg": "9ed9",
	"./list-pointers-svgrepo-com.svg": "062c",
	"./list.svg": "99ad",
	"./mail.svg": "3ae9",
	"./map.svg": "0443",
	"./menu-dots-w.svg": "eabc",
	"./menu-white.svg": "f800",
	"./menu.svg": "d17f",
	"./minus-circle.svg": "4ade",
	"./minus-svgrepo-com.svg": "ab30",
	"./next.svg": "0043",
	"./order.svg": "2965",
	"./paper-recycle.svg": "ee75",
	"./pencil.svg": "e51f",
	"./phone.svg": "c3bb",
	"./plane-svgrepo-com.svg": "5fad",
	"./position.svg": "0791",
	"./print-filled-white.svg": "b976",
	"./print-white.svg": "a13b",
	"./print.svg": "671e",
	"./promotion.svg": "7247c",
	"./qr-code-interactive.svg": "d2a2",
	"./qrc.svg": "41f2",
	"./recycling-recycle.svg": "f5fd",
	"./refresh-circle-white.svg": "a42e",
	"./refresh-warning.svg": "97da",
	"./refresh.svg": "53fa",
	"./right.svg": "37af",
	"./save-w.svg": "3326",
	"./save.svg": "9344",
	"./secure.svg": "2390",
	"./settings.svg": "9174",
	"./sign-out.svg": "8e2f",
	"./status.svg": "c10e",
	"./tags-svgrepo-com.svg": "67a3",
	"./target-2-svgrepo-com.svg": "2d92",
	"./telephone-filled.svg": "67fa",
	"./tick.svg": "812c",
	"./trash.svg": "af22",
	"./tray-dish-svgrepo-com.svg": "4d25",
	"./twitter.svg": "acf9",
	"./undo.svg": "34b1",
	"./upload.svg": "5a96",
	"./user-alt.svg": "9039",
	"./user-white.svg": "1df7",
	"./user.svg": "6aed",
	"./users-2-svgrepo-com.svg": "b1b6",
	"./users.svg": "d956",
	"./whatsapp.svg": "7583"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";